import { render, staticRenderFns } from "./basedetalladasituacion.vue?vue&type=template&id=b792a3b2"
import script from "./basedetalladasituacion.vue?vue&type=script&lang=js"
export * from "./basedetalladasituacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports